import classNames from 'classnames';
import { APP_NAME } from '@hub/libs/constants';

export interface IconProps {
  id: IconID;
  size: number;
  color?: IconColor;
  primary?: boolean;
  useSprite?: boolean;
  title?: string;
}

export enum IconID {
  ADD_SHOPPING_CART = 'igus-icon-add-shopping-cart',
  ASSORTMENT = 'igus-icon-sortiment',
  ARROW_PAGINATION_LEFT = 'igus-icon-arrow-pagination-left',
  ARROW_PAGINATION_RIGHT = 'igus-icon-arrow-pagination-right',
  ARROW_DOWN = 'igus-icon-arrow-down',
  ARROW_LEFT = 'igus-icon-arrow-left',
  ARROW_LEFT_O = 'igus-icon-arrow-left-o',
  ARROW_RIGHT = 'igus-icon-arrow-right',
  ARROW_RIGHT_O = 'igus-icon-arrow-right-o',
  ARROW_UP = 'igus-icon-arrow-up',
  ARROW_TABLE_SORTING = 'igus-icon-arrow-table-sorting',
  CAD_FILES = 'igus-icon-cad-dateien',
  CART = 'igus-icon-cart',
  CHAIN = 'igus-icon-kette',
  CHAT = 'igus-icon-chat',
  CHECK = 'igus-icon-check',
  CHECK_BOUNDING_BOXES = 'igus-icon-check-Bounding_Boxes',
  CHECK_BOX_INDETERMINATE = 'igus-icon-indeterminate-check-box',
  CHECK_BOX_OUTLINE_BLANK = 'igus-icon-check-box-outline-blank',
  CHECK_OUTLINE = 'igus-icon-check-Outline_1_',
  CHEVRON_UP = 'igus-icon-chevron-up',
  CHEVRON_DOWN = 'igus-icon-chevron-down',
  CHEVRON_LEFT = 'igus-icon-chevron-left',
  CHEVRON_RIGHT = 'igus-icon-chevron-right',
  CIRCLE = 'igus-icon-circle',
  CLOCK = 'igus-icon-clock',
  CLOSE_CROSS = 'igus-icon-close-cross',
  CONSULTING = 'igus-icon-beratung',
  COPY_TO_CLIPBOARD = 'igus-icon-copy-clipboard',
  DELIVERY = 'igus-icon-delivery',
  DELIVERY_1_PIECE = 'igus-icon-lieferung-1stueck',
  DELIVERY_TIME = 'igus-icon-lieferzeit',
  DELIVERY_TIME_DOT = 'igus-icon-lieferzeit-dot',
  DELIVERY_TIME_DOT_METADATA_9 = 'igus-icon-lieferzeit-dot-metadata9',
  DELIVERY_TIME_DOT_PATH_2 = 'igus-icon-lieferzeit-dot-path2',
  DELIVERY_TIME_DOT_PATH_4519 = 'igus-icon-lieferzeit-dot-path4519',
  DELETE = 'igus-icon-delete',
  DOWNLOAD = 'igus-icon-download',
  DOWNLOAD_SIMPLE = 'igus-icon-simple-download',
  DOWNLOAD_AVI = 'igus-icon-download-avi',
  DOWNLOAD_DOC = 'igus-icon-download-doc',
  DOWNLOAD_DWG = 'igus-icon-download-dwg',
  DOWNLOAD_DXF = 'igus-icon-download-dxf',
  DOWNLOAD_EXE = 'igus-icon-download-exe',
  DOWNLOAD_MOV = 'igus-icon-download-mov',
  DOWNLOAD_MP3 = 'igus-icon-download-mp3',
  DOWNLOAD_MP4 = 'igus-icon-download-mp4',
  DOWNLOAD_MPEG = 'igus-icon-download-mpeg',
  DOWNLOAD_MPG = 'igus-icon-download-mpg',
  DOWNLOAD_PDF = 'igus-icon-download-pdf',
  DOWNLOAD_CAD = 'igus-icon-download-cad',
  DOWNLOAD_PLAN = 'igus-icon-download-plan',
  DOWNLOAD_PLAN_PATH_825 = 'igus-icon-download-plan-path825',
  DOWNLOAD_PLAN_PATH_827 = 'igus-icon-download-plan-path827',
  DOWNLOAD_PLAN_PATH_829 = 'igus-icon-download-plan-path829',
  DOWNLOAD_PLAN_PATH_831 = 'igus-icon-download-plan-path831',
  DOWNLOAD_PLAN_PATH_833 = 'igus-icon-download-plan-path833',
  DOWNLOAD_PLAN_PATH_835 = 'igus-icon-download-plan-path835',
  DOWNLOAD_PLAN_POLYGON_6 = 'igus-icon-download-plan-polygon6',
  DOWNLOAD_PLAN_POLYGON_8 = 'igus-icon-download-plan-polygon8',
  DOWNLOAD_PLAN_STYLE2 = 'igus-icon-download-plan-style2',
  DOWNLOAD_PLAN_TEXT10 = 'igus-icon-download-plan-text10',
  DOWNLOAD_PPT = 'igus-icon-download-ppt',
  DOWNLOAD_WMV = 'igus-icon-download-wmv',
  DOWNLOAD_XLS = 'igus-icon-download-xls',
  DOWNLOAD_UNKNOWN = 'igus-icon-download-unknown',
  DROPDOWN_DOWN = 'igus-icon-dropdown-down',
  DROPDOWN_UP = 'igus-icon-dropdown-up',
  ERROR = 'igus-icon-error',
  EXPAND = 'igus-icon-expand',
  EXPERT = 'igus-icon-kaufberatung',
  EXPERT_CHAT = 'igus-icon-expertenchat',
  EXTERNAL_LINK = 'igus-icon-external-link',
  FILE_CAD = 'igus-icon-cad-dateien',
  FILTER_ALT = 'igus-icon-filter-alt',
  FILTER_ALT_OFF = 'igus-icon-filter-alt-off',
  FIRST_PAGE = 'igus-icon-first-page',
  FREE_SAMPLE = 'igus-icon-gratismuster',
  FULL_SCREEN_OPEN = 'igus-icon-full-screen-open',
  FULL_SCREEN_EXIT = 'igus-icon-full-screen-exit',
  GRID = 'igus-icon-grid',
  GRID_3D = 'igus-icon-grid-3D',
  HANDY_MAN = 'igus-icon-handy-man',
  H24_DELIVERY = 'igus-icon-24h-lieferung',
  INFO = 'igus-icon-info',
  INFO_INFO = 'igus-icon-info-info',
  INFO_CIRCLE = 'igus-icon-info-circle',
  INFO_CIRCLE_GRAY = 'igus-icon-info-circle-gray',
  INFO_CIRCLE_MODERN = 'igus-icon-info-circle-modern',
  INFO_CIRCLE_MODERN_FILLED = 'igus-icon-info-circle-modern-filled',
  JOB_APPLICATION_PROCESS = 'igus-icon-bewerbungsprozess',
  JOB_APPLICATION_PROCESS_LEVEL_3 = 'igus-icon-bewerbungsprozess-Ebene_3',
  JOB_APPLICATION_PROCESS_LEVEL_4 = 'igus-icon-bewerbungsprozess-Ebene_4',
  LAST_PAGE = 'igus-icon-last-page',
  LIFETIME_CALCULATOR = 'igus-icon-lebensdauerrechner',
  LIST = 'igus-icon-list',
  LOCATION = 'igus-icon-standort',
  LOCATION_LEVEL_4 = 'igus-icon-standort-Ebene_4',
  MAGNIFIER = 'igus-icon-lupe',
  MAGNIFIER_2 = 'igus-icon-lupe--',
  MAGNIFIER_FILL = 'igus-icon-lupe-Fill-1',
  MAGNIFIER_FILL_2 = 'igus-icon-lupe-Fill-2',
  MAGNIFIER_GROUP_4 = 'igus-icon-lupe-Group-4',
  MAGNIFIER_GROUP_7 = 'igus-icon-lupe-Group-7',
  MAGNIFIER_PAGE = 'igus-icon-lupe-Page-1',
  MAGNIFIER_PRODUCTPAGE_PRICE_XL = 'igus-icon-lupe-Produktseite_Preis_XL',
  MAIL = 'igus-icon-mail',
  MENU = 'igus-icon-menu',
  MINUS = 'igus-icon-minus',
  PDF_FILES = 'igus-icon-pdf-dateien',
  PERCENT = 'igus-icon-percent',
  PHONE = 'igus-icon-phone',
  PHONE_2 = 'igus-icon-phone-02',
  PHONE_XMLID_2 = 'igus-icon-phone-XMLID_2_',
  PHONE_XMLID_4 = 'igus-icon-phone-XMLID_4_',
  PHONE_MODERN = 'igus-icon-phone-modern',
  PHOTO_LIBRARY = 'igus-icon-foto-library',
  PLUS = 'igus-icon-plus',
  PRICE_REQUEST = 'igus-icon-preisanfrage',
  PRINCIPLES = 'igus-icon-prinzipien',
  PRINCIPLES_LEVEL_3 = 'igus-icon-prinzipien-Ebene_3',
  PROFILE = 'igus-icon-profil',
  QUESTION_MARK = 'igus-icon-question-mark',
  REMINDER_LIST = 'igus-icon-merkliste',
  REQUEST_QUOTE = 'igus-icon-request-quote',
  SEARCH = 'igus-icon-search',
  SHARE = 'igus-icon-share',
  SQUARE = 'igus-icon-square',
  TABLE_CONDITIONAL = 'igus-icon-tabelle-bedingt',
  TABLE_CONSISTENT = 'igus-icon-tabelle-bestaendig',
  TABLE_INCONSISTENT = 'igus-icon-tabelle-unbestaendig',
  TABLE_MINUS = 'igus-icon-tabelle-minus',
  TABLE_PLUS = 'igus-icon-tabelle-plus',
  TABLE_PLUS__XL = 'igus-icon-tabelle-plus-Tabelle_XL',
  TABLE_PLUS_COMBINED = 'igus-icon-tabelle-plus-Combined-Shape',
  TABLE_PLUS_SYMBOLS = 'igus-icon-tabelle-plus-symbos',
  THREE_ARROWS = 'igus-icon-3arrow',
  THREE_ARROWS_DOWN = 'igus-icon-3arrow_down',
  THREE_DIMENSIONAL_MODEL = 'igus-three-dimensional-model',
  WARNING = 'igus-icon-warning',
  WORK = 'igus-icon-arbeiten',
  WORK_LEVEL_3 = 'igus-icon-arbeiten-Ebene_3',
  WORK_LEVEL_4 = 'igus-icon-arbeiten-Ebene_4',
  UPLOAD = 'igus-icon-upload',
  UPLOAD_FILE = 'igus-icon-upload-file',
  ZIP_FILES = 'igus-icon-zip-dateien',
  ZUKEN = 'zuken.svg',
  GLOBE = 'igus-icon-globe',
  WHATSAPP = 'igus-icon-whatsapp',
  ZALO = 'igus-icon-zalo',
  ZOOM_IN = 'igus-icon-zoom-in',
  LINE = 'igus-icon-line',
  ECHAIN_SELECTION = './echain/echain_selection.svg',
  ECHAIN_AE_SELECTION = './echain/echain_selection_AE.svg',
  ECHAIN_TRAY_SELECTION = './echain/echain_selection_TRAY.svg',
  ECHAIN_IA_SELECTION = './echain/echain_selection_IA.svg',
}

export enum IconColor {
  ORANGE = 'text-igus-primary',
  RED = 'text-red-0',
  GREEN = 'text-igus-green',
  WHITE = 'text-white',
  BLACK = 'text-black',
  DARK_GRAY = 'text-gray-800',
  GRAY = 'text-gray-300',
  MID_GRAY = 'text-[#545454]',
  BLUE = 'text-igus-info ',
  DELIVERY_FASTLANE = 'text-availability-fastlane',
  DELIVERY_FAST = 'text-availability-fast',
  DELIVERY_SLOW = 'text-availability-slow',
  LIGHT_GRAY = 'text-gray-200',
  WHATSAPP = 'icon-whatsapp',
}

// additional icon sizes should be added in this dictionary and interface with the iconSizes
const iconSizes = {
  1: 'w-1 h-1',
  2: 'w-2 h-2',
  3: 'w-3 h-3',
  4: 'w-4 h-4',
  5: 'w-5 h-5',
  6: 'w-6 h-6',
  7: 'w-7 h-7',
  8: 'w-8 h-8',
  9: 'w-9 h-9',
  10: 'w-10 h-10',
  11: 'w-11 h-11',
  12: 'w-12 h-12',
  13: 'w-13 h-13',
  14: 'w-14 h-14',
  15: 'w-15 h-15',
  16: 'w-16 h-16',
};

// see tailwind for w- & h- sizes
export interface IconSizes {
  1: 'w-1 h-1';
  2: 'w-2 h-2';
  3: 'w-3 h-3';
  4: 'w-4 h-4';
  5: 'w-5 h-5';
  6: 'w-6 h-6';
  7: 'w-7 h-7';
  8: 'w-8 h-8';
  9: 'w-9 h-9';
  10: 'w-10 h-10';
  11: 'w-11 h-11';
  12: 'w-12 h-12';
  13: 'w-13 h-13';
  14: 'w-14 h-14';
  15: 'w-15 h-15';
  16: 'w-16 h-16';
}

export const Icon = ({ id, color, size, primary = true, useSprite = true, title }: IconProps) => {
  if (!useSprite) {
    return <img src={`/_${APP_NAME}/icons/${id}`} alt={id} />;
  }

  return (
    <>
      <svg
        role="img"
        data-testid="icon-svg"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={classNames(
          'inline-block',
          'fill-current',
          'pointer-events-none',
          (iconSizes as IconSizes)[size as keyof IconSizes],
          color || (primary && IconColor.ORANGE),
          color === IconColor.DARK_GRAY && 'group-hover:text-white'
        )}
      >
        {title && <title data-testid="icon-svg-title">{title}</title>}
        <use data-testid="icon-svg-use" xlinkHref={`/_${APP_NAME}/icons/icon-sprite.svg#${id}`}>
          {title && <title data-testid="icon-svg-use-title">{title}</title>}
        </use>
      </svg>
      <span className="sr-only">{id}</span>
    </>
  );
};
